export const getStateName = (code, states) => {
  const state = states.find((state) => state.Code === code);
  return state ? state.State : code;
};

export const getCountryName = (code, countryCodes) => {
  const country = countryCodes.find((country) => country.Code === code);
  return country ? country.Country : code;
};

const sourceMapping = {
  api: 'API',
  web: 'WEB',
  sftp: 'Bulk Upload - SFTP',
  bulk_upload: 'Bulk Upload - WebApp',
};

export const formatSource = (value) => {
  if (sourceMapping[value]) {
    return sourceMapping[value];
  }
  return value
    ?.split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// Helper function to check if a specific position in the 8-digit transaction type code is "1"
export const transactionTypePositionCheck = (profileExecutionId, position) => {
  // position is 1-based, so subtract 1 for 0-based index
  return profileExecutionId && profileExecutionId[position - 1] === '1';
};

export const isMarginScheme = (profileExecutionId) => transactionTypePositionCheck(profileExecutionId, 3);

export const safeParseFloat = (value) => {
  const num = parseFloat(value);
  return isNaN(num) ? 0 : num;
};

export const getAllFilesTotalSize = (files) => {
  return files.reduce((total, file) => total + file.size, 0);
};
